import React,{Component,useState,useEffect,Fragment} from "react";
import axios from "axios";
import Login from "./Login";

import { Navigate  } from 'react-router-dom';
import { CheckCircleIcon, XIcon,ExclamationCircleIcon  } from '@heroicons/react/solid';
import { Transition } from '@headlessui/react'
import mainLogo from'../mglogo.png';


class Register extends Component{
 
  constructor(props) {
    super(props);
    this.state = {
      showmsg: false,
      redirect: false,
      name:'',
      email:'',
      password:'',
      success:'false',
      error_list:[],
    };
  }
  
   
    //const [show, setShow] = useState(false)

    handleInput= (e) =>{

        this.setState({
            [e.target.name]: e.target.value
        });
    }
    
    signUp =async (e)=>{
      
        e.preventDefault();    
        
        const res= await axios.post('public/api/nregister',this.state); 
        
        if(res.data.success){
          
            this.setState({
                name:'',
                email:'',
                password:'',
            });

            this.setState({ showmsg: true })
            
            setTimeout(function() { //Start the timer
              this.setState({ redirect: true }) //After 1 second, set render to true
                  }.bind(this), 1000)

          //  localStorage.setItem('token','res.data.token');
            
          
            
            
        }else{
           
            this.setState({error_list:res.data.data});
            //this.setState({ show: true })
        }
       
    }

render(){

  if(this.state.redirect){
    return <Navigate to={'/Login'} />
}

    return (
        <>
          {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-50">
            <body class="h-full">
            ```
          */}
          
        
          <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
             
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign Up your account</h2>
              <p className="mt-2 text-center text-sm text-gray-600">
                  Or{' '}
                  <a href={"./Login"}  className="font-medium text-indigo-600 hover:text-indigo-500">
                    Login to your Account
                  </a>
                </p>
            </div>
    
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
              <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form onSubmit={this.signUp} className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                      UserName
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        onChange={this.handleInput}
                        autoComplete="email"
                        placeholder="Email Id"
                        value={this.state.email}
                        
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <p className="mt-2 text-sm text-red-600" id="email-error">
                     {this.state.error_list.email}
                    </p>
                  </div>
    
                  <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Enter your password"
                        onChange={this.handleInput}
                        autoComplete="current-password"
                        value={this.state.password}
                        
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        aria-describedby="password-error"     
                     />
                    </div>

                    <p className="mt-2 text-sm text-red-600" id="email-error">
                     {this.state.error_list.password}
                    </p>
                  </div>

                  <div>
                    <label htmlFor="Name" className="block text-sm font-medium text-gray-700">
                      Name
                    </label>
                    <div className="mt-1">
                      <input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Your Name"
                        onChange={this.handleInput}
                        autoComplete="name"
                        value={this.state.name}

                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                      
                      
                    </div>
                   

                    <p className="mt-2 text-sm text-red-600" id="email-error">
                     {this.state.error_list.name}
                    </p>
                  </div>
    
                  
    
                  <div>
                    <button
                      type="submit"
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Sign Up
                    </button>
                  </div>
                </form>
    
               
              </div>
            </div>
          </div>
        


           {/* Global notification live region, render this permanently at the end of the document */}
           <div
        aria-live="assertive"
        className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
      >
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={this.state.showmsg}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">Successfully Registered!</p>
                    <p className="mt-1 text-sm text-gray-500">You can Login now</p>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button
                      className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => {
                        this.setState({ showmsg: false })
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
        </>
      )
}

}

export default Register;


